import { endpoints } from 'Constants';

const ticketServices = {
	list: (params) => ({
		baseURL: endpoints.TICKET.LIST(),
		method: 'GET',
		params: params?.query,
	}),

	index: (params) => ({
		baseURL: endpoints.TICKET.INDEX(params?.id),
		method: 'GET',
	}),

	create: (params) => ({
		baseURL: endpoints.TICKET.CREATE(),
		method: 'POST',
		data: params,
	}),

	support_ticket: (params) => ({
		baseURL: endpoints.TICKET.SUPPORT_TICKET(params),
		method: 'GET',
	}),

	log: (params) => ({
		baseURL: endpoints.TICKET.LOGS(params?.id),
		method: 'GET',
	}),

	log: (params) => ({
		baseURL: endpoints.TICKET.LOGS(params?.id),
		method: 'GET',
	}),
};

export default ticketServices;
